import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { partnerSchema } from '../schemas/partner.schema';

/**
 * Get a list of partners
 * @returns List of Partners
 */
export function getPartners(this: unknown) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).partnersUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(z.array(partnerSchema)));
}
